export default __webpack_public_path__ + "static/media/expense_tracker.142f63b8.png";